module.exports = __webpack_public_path__ + "static/media/art.7d24b7ca.jpg";